import React from "react";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import About from "./pages/About";
import Careers from "./pages/Careers";
import CodeOfEthics from "./pages/CodeOfEthics";
import Disclaimer from "./pages/Disclaimer";
import Docs from "./pages/Docs";
import Terms from "./pages/Terms";
import Pricing from "./pages/Pricing";
import Privacy from "./pages/Privacy";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Footer from "./components/Footer";

function App() {
  return (
    <div
      className="container"
      style={{ position: "relative", minHeight: "100%" }}
    >
      <Router>
        <Navbar />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/about" component={About} />
          <Route path="/careers" component={Careers} />
          <Route path="/code_of_ethics" component={CodeOfEthics} />
          <Route path="/disclaimer" component={Disclaimer} />
          <Route path="/docs" component={Docs} />
          <Route path="/terms" component={Terms} />
          <Route path="/pricing" component={Pricing} />
          <Route path="/privacy" component={Privacy} />
        </Switch>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
